import { useState } from 'react'

// ── ShowSynopsis ──────────────────────────────────────────────────────────────
// The show's premise, at the TOP of the About tab. Gina flagged that "About" jumped
// straight to how-to-watch + episodes and never said what the show is actually about
// (2026-07-22). Clamped to a few lines with Read more, so it answers "what is this?"
// first without shoving the tracking surfaces (Up Next) far down the page.
export function ShowSynopsis({ text }) {
  const [open, setOpen] = useState(false)
  if (!text || !text.trim()) return null
  const long = text.length > 180
  return (
    <div style={{ marginBottom: 14 }}>
      <p style={{
        color: 'var(--text-muted)', fontSize: 14, lineHeight: 1.6, margin: 0,
        ...(open || !long ? {} : { display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }),
      }}>{text}</p>
      {long && (
        <button onClick={() => setOpen(o => !o)} style={{
          background: 'none', border: 'none', color: 'var(--amber)', fontSize: 12.5, fontWeight: 700,
          cursor: 'pointer', fontFamily: 'var(--font)', padding: '5px 0 0',
        }}>
          {open ? 'Show less' : 'Read more'}
        </button>
      )}
    </div>
  )
}
